import React, { useState, useEffect, useContext } from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";
import NavbarButtons from "./NavbarButtons";
import { LanguageContext } from "../../../context/LanguageContext";
import SecondNavbar from "./SecondNavbar";
import YourMheroDropdown from "../../../components/YourMheroDropDown/YourMheroDropDown";
import ExploreDropdown from "../../../components/YourMheroDropDown/ExploreDropDown";

const Navbar = () => {
  const { texts } = useContext(LanguageContext);
  const [scrolled, setScrolled] = useState(false);
  const [showSecondNavbar, setShowSecondNavbar] = useState(false);
  const [hoverMhero, setHoverMhero] = useState(false);
  const [hoverExplore, setHoverExplore] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const hero = document.getElementById("hero-section");
      const heroHeight = hero ? hero.offsetHeight : 0;

      setScrolled(window.scrollY > 15);
      setShowSecondNavbar(window.scrollY > heroHeight / 2);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (showSecondNavbar) return <SecondNavbar /> ;
 

  return (
    <div
        className={`navbar ${scrolled ? "scrolled" : ""} ${hoverMhero ? "nav-black" : ""} ${hoverExplore ? "nav-black" : ""}` }
      onMouseLeave={() => {
        setHoverMhero(false);
        setHoverExplore(false);
      }}
    >
      <div className="nav-left">
        <Link to="/" className="logo"></Link>
      </div>

      <div className="nav-mid">
        <ul>
          {/* Your MHERO */}
          <div
            className="link-arr"
            onMouseEnter={() => setHoverMhero(true)}
          >
            <div className="nav-link y">
              {texts.navbar.yourMhero}
              <span className={`arrow-container ${hoverMhero ? "rotate" : ""}`}>
                <span className="arrow-down"></span>
              </span>
            </div>
          </div>

          <Link to="/aboutUs" className="nav-link au">
            {texts.navbar.aboutUs}
          </Link>

            <Link to="/services" className="nav-link au">
            {texts.navbar.services}
          </Link>

        

       

          {/* Explore MHERO */}
          <div
            className="link-arr"
            onMouseEnter={() => setHoverExplore(true)}
          >
            <div className="nav-link y">
              {texts.navbar.explore}
              <span className={`arrow-container ${hoverExplore ? "rotate" : ""}`}>
                <span className="arrow-down"></span>
              </span>
            </div>
          </div>

            <Link to="/contactUs" className="nav-link au">
            {texts.navbar.contactUs}
          </Link>

         


        </ul>
      </div>

      <div className="nav-right">
        <NavbarButtons />
      </div>

      {/* Dropdowns */}
      <YourMheroDropdown
        isOpen={hoverMhero}
        onMouseEnter={() => setHoverMhero(true)}
        onMouseLeave={() => setHoverMhero(false)}
      />

      <ExploreDropdown
        isOpen={hoverExplore}
        onMouseEnter={() => setHoverExplore(true)}
        onMouseLeave={() => setHoverExplore(false)}
      />
    </div>
  );
};

export default Navbar;
